<template>
    <div class="body">
        <div class="topic_page" v-loading="is_loading" element-loading-text="加载中">
            <h1>{{name}}</h1>
            <ol style="padding: 0 80px">
                <div v-for="(item,index) in ques_list">
                    <div class="topic-type">
                        {{item.type_name}}&nbsp;&nbsp;(&nbsp;{{item.score}}分&nbsp;)
                    </div>
                    <li >
                        <div class="topic_content">
                            <div class="topic_title">
                                <div style="line-height: 25px">
                                    {{index + 1}}.&nbsp;
                                </div>
                                <div v-html="item.html">

                                </div>
                            </div>
                            <!--选项 -->
                            <!--    单选-->
                            <ul v-if="item.type === 'radio' || item.type === 'checkbox'" style="list-style: none">
                                <li v-for="(op,opIndex) in item.options">
                                    <div class="option">
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 1">A
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 2">B
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 3">C
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 4">D
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 5">E
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 6">F
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 7">G
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 8">H
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 9">I
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 10">J
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 11">K
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 12">L
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 13">M
                                        </div>
                                        <div class="letter" :class="{'letter_select':op.is_selected}"
                                             v-show="op.sort_num === 14">N
                                        </div>
                                        <div class="option_title" v-html="op.title"></div>
                                    </div>
                                </li>
                            </ul>

                            <!--    判断-->
                            <div v-show="item.type === 'boolean'">
                                <div class="boolean_option" @click="booleanTrue(index,true)">
                                    <div class="letter">
                                        <svg class="icon" aria-hidden="true">
                                            <use xlink:href="#icon-li-hook"></use>
                                        </svg>

                                    </div>
                                    <div>正确</div>
                                </div>
                                <div class="boolean_option" @click="booleanTrue(index,false)">
                                    <div class="letter">
                                        <svg class="icon" aria-hidden="true">
                                            <use xlink:href="#icon-li-fork"></use>
                                        </svg>
                                    </div>
                                    <div>错误</div>
                                </div>
                            </div>

                            <!--      单选/多选/判断    答案   -->
                            <div class="answer" v-if="item.type ==='radio' || item.type ==='boolean' || item.type ==='checkbox'">
                                <div class="title">答案</div>
                                <div v-if="item.type ==='boolean'">
                                    <span v-if="item.iscorrect === '0'">正确答案： 错误</span>
                                    <span v-if="item.iscorrect === '1'">正确答案： 正确</span>
                                </div>
                                <div v-if="item.type ==='radio' || item.type ==='checkbox'">
                                    正确答案： <span style="color: #409EFF">{{item.right_answer}}</span>
                                </div>

                                <!--          答案   -->
                                <div v-if="item.type !== 'radio' & item.type !== 'checkbox' & item.type !== 'boolean'">
                                    暂不支持作答
                                </div>


                            </div>
                        </div>

                        <!--   关键词-->
                        <div class="keyword" v-if="item.type != 'radio' && item.type != 'checkbox'  && item.type != 'boolean'">
                            关键词：
                            <div v-for="(itemTag,indexTag) in item.tagData">{{itemTag}}</div>
                        </div>

                        <div class="analysis_text">
                            <div class="title">解析</div>
                            <div class="ql-editor" v-html="item.resolution"></div>
                        </div>
                        <div class="empty_box"></div>

                    </li>
                </div>

            </ol>
        </div>

    </div>
</template>

<script>

    export default {

        name: 'topicPreview',
        data() {
            return {
                ques_id: '',
                name: '',
                ques_list: [],
                is_select: false,
                option_letter: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
                is_loading:true
            };
        },
        created() {
            this.name = this.$route.query.name;
            this.ques_id = this.$route.query.ques_id;
            this.getQuestionList();
        },
        methods: {
            booleanTrue(index, boolean) {
                this.ques_list[index].answer = boolean;
            },
            option(index, opIndex) {
                this.ques_list[index].options.forEach((item, index) => {
                    if (item.is_selected === true) {
                        item.is_selected = false;
                    }
                });
                this.ques_list[index].options[opIndex].is_selected = true;
            },
            getQuestionList() {
                this.$get(this.BASEURL + '/question/preview?ques_id=' + this.ques_id).then((res) => {
                    if (res.code === 200) {
                        this.ques_list = res.ques_list;
                        this.ques_list.forEach((item, index) => {
                            if (item.options) {
                                this.ques_list[index].right_answer = ''
                                item.options.forEach((it, id) => {
                                    if (it.is_correct === true) {
                                        this.ques_list[index].right_answer += this.option_letter[id];
                                    }
                                });
                            }

                            if (item.key_words && item.key_words.length > 0){
                                item.tagData = []
                                item.key_words.forEach((itemTag,indexTag)=>{
                                    item.tagData.push(itemTag.key_word)
                                })
                            }

                        });

                        console.log('this.ques_list', this.ques_list);
                        this.is_loading = false

                    } else {
                        this.$message.error(res.error);
                    }
                });
            }
        }

    };
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
        padding: 0;
    }
    li{
        list-style: none;
    }

    .body {
        color: $black;
        height: 100vh;
        overflow: auto;
        min-width: 1226px;
        background-color: #F3F6FB;
    }

    .topic-type{
        margin-bottom: 8px;
        font-weight: bold;
    }

    .empty_box {
        width: 100%;
        height: 20px;
        border-top: 1px solid #cccccc;
        margin-top: 20px;
    }

    .topic_page {
        background-color: #FFFFFF;
        margin-left: auto;
        margin-right: auto;
        width: 920px;

        h1 {
            color: $blue;
            text-align: center;
            padding: 35px 0;
        }
    }

    .topic_content {
        .topic_title {
            display: flex;
            margin-bottom: 24px;
        }

        .option {
            margin: 16px 0;
            display: flex;
            align-items: center;
        }

        .option:hover {
            background-color: #EFEFEF;
        }
    }

    .letter {
        flex: 0 0 auto;
        margin-right: 12px;
        display: inline-block;
        color: $blue;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid $blue;
        text-align: center;
        line-height: 24px;
        .icon{
            color: $blue;
        }

    }

    .letter_select {
        /*flex: 0 0 auto;*/
        margin-right: 12px;
        display: inline-block;
        color: white;
        background-color: $blue;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #dadada;
        text-align: center;
        line-height: 24px;
    }

    .boolean_letter {
        font-size: 22px;
        /*flex: 0 0 auto;*/
        margin-right: 12px;
        display: inline-block;
        color: $blue;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 1px solid #dadada;
        text-align: center;
        line-height: 35px;
    }

    .boolean_letter_select {
        font-size: 22px;
        /*flex: 0 0 auto;*/
        margin-right: 12px;
        display: inline-block;
        color: white;
        background-color: $blue;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 1px solid #dadada;
        text-align: center;
        line-height: 35px;
    }

    .boolean_option {
        margin: 16px 0;
        display: flex;
        align-items: center;
    }

    .boolean_option:hover {
        background-color: #EFEFEF;
    }
    .answer{
        margin-top: 20px;

    }
    .analysis_text{
        margin-top: 20px;
    }
    .keyword{
        margin: 16px 0;
        display: flex;align-items: center;
        div{
            font-size: 14px;
            margin: 0 8px;
            padding: 2px 16px;
            background-color: #E3F0FF;
            border-radius: 20px;
            color: $blue;
            line-height: 24px;
        }
    }

</style>